import { MaintenanceWindow, MaintenanceStatus, MaintenanceWindowPhase } from './Maintenance.types';

export const sortMaintenanceWindows = (windows: MaintenanceWindow[]) => {
  return [...windows].sort((a, b) => a.startDate.getTime() - b.startDate.getTime());
};

export const getWindowPhase = (now: Date, window: MaintenanceWindow): MaintenanceWindowPhase => {
  const nowTime = now.getTime();
  const startTime = window.startDate.getTime();
  const endTime = window.endDate.getTime();

  if (nowTime < startTime) {
    return 'before';
  }

  if (nowTime >= startTime && nowTime < endTime) {
    return 'ongoing';
  }

  return 'completed';
};

export const getMaintenanceStatus = (now: Date, windows: MaintenanceWindow[]): MaintenanceStatus => {
  const sortedWindows = sortMaintenanceWindows(windows);

  if (sortedWindows.length === 0) {
    return {
      phase: 'none',
      window: null,
    };
  }

  const ongoingWindow = sortedWindows.find((window) => getWindowPhase(now, window) === 'ongoing');

  if (ongoingWindow) {
    return {
      phase: 'ongoing',
      window: ongoingWindow,
    };
  }

  const nextWindow = sortedWindows.find((window) => getWindowPhase(now, window) === 'before');

  if (nextWindow) {
    return {
      phase: 'before',
      window: nextWindow,
    };
  }

  const lastWindow = sortedWindows[sortedWindows.length - 1];

  return {
    phase: 'completed',
    window: lastWindow,
  };
};
